/**
 * 企微换票后 JWT 的读写策略（与历史 his 行为兼容：默认可从 local 或 session 读取）。
 */
import { clearMsOrgSessionVerifyCache } from "./wecomMsOrgApi";
export function getWecomMsOrgToken(tokenKey, mode) {
    if (mode === void 0) { mode = "both"; }
    try {
        if (mode === "local")
            return localStorage.getItem(tokenKey);
        if (mode === "session")
            return sessionStorage.getItem(tokenKey);
        return localStorage.getItem(tokenKey) || sessionStorage.getItem(tokenKey);
    }
    catch (_a) {
        return null;
    }
}
/**
 * 写入 JWT。localStorage 与 sessionStorage 必须分别 try/catch：
 * 企微 WebView 常出现「其一抛错或不可用、另一路仍可用」；若共用一个 try，前者抛错会导致后者根本不执行，
 * 或 local 写入失败时仍残留旧 token，而 getWecomMsOrgToken(mode=both) 优先读 local，换票 roundtrip 会误判失败。
 */
export function setWecomMsOrgToken(tokenKey, token, mode) {
    if (mode === void 0) { mode = "both"; }
    if (mode === "local" || mode === "both") {
        try {
            localStorage.removeItem(tokenKey);
        }
        catch (_a) {
            // ignore
        }
        try {
            localStorage.setItem(tokenKey, token);
        }
        catch (_b) {
            // ignore — 例如企微禁用 localStorage
        }
    }
    if (mode === "session" || mode === "both") {
        try {
            sessionStorage.removeItem(tokenKey);
        }
        catch (_c) {
            // ignore
        }
        try {
            sessionStorage.setItem(tokenKey, token);
        }
        catch (_d) {
            // ignore — 例如会话级存储不可用
        }
    }
}
export function clearWecomMsOrgToken(tokenKey, mode) {
    if (mode === void 0) { mode = "both"; }
    if (mode === "local" || mode === "both") {
        try {
            localStorage.removeItem(tokenKey);
        }
        catch (_a) {
            // ignore
        }
    }
    if (mode === "session" || mode === "both") {
        try {
            sessionStorage.removeItem(tokenKey);
        }
        catch (_b) {
            // ignore
        }
    }
    clearMsOrgSessionVerifyCache();
}
